import { ApiRequestError } from '../apiError';

// A rejected fetch() surfaces as a TypeError whose message is engine-specific:
//   Chromium: "Failed to fetch"
//   Firefox:  "NetworkError when attempting to fetch resource."
//   WebKit (Safari + ALL iOS browsers, incl. Chrome iOS): "Load failed"
// The earlier /fetch/i test silently missed WebKit's "Load failed" (no "fetch"
// substring), so every mobile-Safari network blip during boot / token refresh
// paged us as a handled exception (LUTIQ-6A / LUTIQ-60). Match all three
// explicitly; do NOT blanket-match every TypeError — a logic bug such as a
// null-deref must still surface. Module-level so it isn't re-compiled per call.
const TRANSIENT_FETCH_MESSAGE = /failed to fetch|networkerror|load failed/i;

// 429 responses plus the network-level `TypeError` a rejected `fetch()` throws
// are expected blips during Keycloak init, boot, and token refresh when
// Keycloak / the API is briefly unreachable. Capturing them floods Sentry
// without giving us anything actionable — the next tick either recovers or
// promotes to a real, different error — so callers breadcrumb-and-retry
// instead of paging us.
export const isTransientAuthError = (err: unknown): boolean => {
  if (err instanceof ApiRequestError) {
    return err.status === 429 || err.status === 0 || err.status >= 500;
  }
  if (err instanceof TypeError) {
    return TRANSIENT_FETCH_MESSAGE.test(err.message);
  }
  return false;
};
